export namespace StripHtmlHelper {
  /**
		Removes HTML tags related to conceptual elements get from BE response
		endpoint: /empolis/v1/search
	*/
  export enum StripHtmlParams {
    Concept = 'concept',
  }
}
